import APITemplate from './APITemplate'

const template = APITemplate('/car-document')

export default {
  ...template,
  getScans (documentId) {
    const request = '/car-document/scans?id=' + documentId
    return fetch(request, {
      method: 'GET',
      credentials: 'include',
      redirect: 'error',
      headers: template.headers
    }).then(template.errorHandler)
  }
}
